import { NextPage } from 'next';
import Head from 'next/head';
import styled, { ThemeProvider } from 'styled-components';
import Footer from '../components/BrandSitesV2/common/Footer';
import { BrandSitesV2GlobalStyle, BrandSitesV2Theme } from '../components/BrandSitesV2/common/GlobalStyle';
import Header from '../components/BrandSitesV2/common/Header';
import HeroSection from '../components/BrandSitesV2/HomeClean/HeroSection';
import PriceSection from '../components/BrandSitesV2/HomeClean/PriceSection';
import InfoSection from '../components/BrandSitesV2/HomeClean/InfoSection';
import RegionSection from '../components/BrandSitesV2/HomeClean/RegionSection';
import ServiceRangeSection from '../components/BrandSitesV2/HomeClean/ServiceRangeSection';
import ServiceTypeSection from '../components/BrandSitesV2/HomeClean/ServiceTypeSection';
import SystemSection from '../components/BrandSitesV2/HomeClean/SystemSection';
import StickyAppDownloadButton from '../components/BrandSitesV2/common/StickyAppDownloadButton';
import { GoogleAnalyticsBrandsiteScript } from '../components/GoogleAnanlytics';

const HomeCleanPage: NextPage = () => {
  return (
    <>
      <Head>
        <title>청소연구소 - 가사청소</title>
        <meta property="og:title" content="청소연구소 - 가사청소" />
        <meta
          name="description"
          content="집 청소부터 빨래, 집안일, 설거지까지 가사도우미와 청소가 필요하다면 청소연구소"
        />
        <meta
          property="og:description"
          content="집 청소부터 빨래, 집안일, 설거지까지 가사도우미와 청소가 필요하다면 청소연구소"
        />
        <meta
          name="keywords"
          content="청소연구소,집청소,가사도우미,청소도우미,파출부,집안일,청연,원룸청소,화장실청소,청연"
        />
        <meta
          name="og:keywords"
          content="청소연구소,집청소,가사도우미,청소도우미,파출부,집안일,청연,원룸청소,화장실청소,청연"
        />
        <meta property="og:url" content="https://www.cleaninglab.co.kr/home_clean" />
        <link rel="canonical" href="https://www.cleaninglab.co.kr/home_clean" />
        <meta property="og:image" content="https://cleanhome-web.cleaninglab.co.kr/brandsite/home_clean/thumb.png" />
        <meta property="og:image:width" content="600" />
        <meta property="og:image:height" content="360" />
        <meta property="og:image:type" content="image/png" />
        <GoogleAnalyticsBrandsiteScript />
      </Head>
      <BrandSitesV2GlobalStyle />
      <ThemeProvider theme={BrandSitesV2Theme}>
        <Header />
        <Main>
          <HeroSection />
          <InfoSection />
          <StickyContainer>
            <ServiceTypeSection />
            <ServiceRangeSection />
            <RegionSection />
            <PriceSection />
            <SystemSection />
            <StickyAppDownloadButton />
          </StickyContainer>
        </Main>
        <Footer />
      </ThemeProvider>
    </>
  );
};

export default HomeCleanPage;

const Main = styled.main``;

const StickyContainer = styled.div``;
